// src/utils/getImages.js

// Helper function to import all files in a folder
export const importAll = (r) => r.keys().map(r);

// Automatically import all image files  s
export const partnerLogos = importAll(require.context('../assets/images/partners', false, /\.(png|jpe?g|svg)$/));